import React, { useEffect, useState } from "react";
import SearchProduct from "./_components/add-quick-order/serach-product/SearchProduct";
import AddProductModal from "./_components/add-product-modal/AddProductModal";
import { warningMessage } from "../../../../../utils/toastify-message/ToastifyMessage";
import QuickProductsTable from "./_components/add-quick-order/quick-products-table/QuickProductsTable";
import Button from "../../../../../components/common/button/Button";

const { forwardRef, useRef, useImperativeHandle } = React;

const ProductsPack = forwardRef(({ handlePack, oldPack }, ref) => {
  const [showModal, setShowModal] = useState(false);
  const [products, setProducts] = useState([]);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {},
  }));
  const addProductRef = useRef();
  const searchProductRef = useRef();

  const handleNewPack = () => {
    handlePack(products);
    setShowModal(false);
  };

  useEffect(() => {
    if (oldPack?.length) {
      setProducts(oldPack);
    }
  }, [oldPack]);

  const handleProduct = (data) => {
    const isExist = products.filter((item) => {
      return (
        item.productSku === data?.productSku &&
        item.productVarSku === data?.productVarSku
      );
    });
    if (isExist.length) {
      warningMessage("این محصول از قبل موجود است.");
    } else {
      setProducts([...products, data]);
    }
  };

  const deleteProduct = (indedx) => {
    const newProducts = [...products];
    if (indedx > -1 && indedx < newProducts.length) {
      newProducts.splice(indedx, 1);
    }
    setProducts(newProducts);
  };

  const handleShowProduct = (data) => {
    addProductRef.current.showModal(data);
  };

  return (
    <>
      <AddProductModal ref={addProductRef} handleProduct={handleProduct} />
      <div
        className={`admin-edit-backdrop fixed top-0 right-0 w-full h-full transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        hidden={!showModal}
        role="dialog"
        aria-label="محصولات پک"
        aria-modal="true"
        className={`admin-edit-drawer w-full h-full overflow-y-scroll  bg-white shadow-md z-40 rounded-3xl p-4 transition-all absolute top-0 -left-[120%] ${
          showModal && "!left-0 is-open"
        }`}
      >
        <div className="flex w-full items-center justify-between">
          <h4>افزودن محصولات پک</h4>
          <Button
            onClick={handleNewPack}
            type="button"
            color="primary"
            text="بازگشت"
          />
        </div>
        <div className="relative">
          <div className="w-full">
            <div className="mt-4 w-full  gap-4">
              <div className="relative">
                <button
                  onClick={() => searchProductRef.current.showModal()}
                  className="absolute w-full h-full top-0 right-0 z-10"
                ></button>
                <div class="w-full mx-auto">
                  <div class="relative">
                    <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                      <svg
                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 20"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                        />
                      </svg>
                    </div>
                    <input
                      type="search"
                      id="default-search"
                      class="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="جست‌و‌جو محصول ..."
                    />
                  </div>
                </div>
              </div>

              <h4 className="mt-6">لیست محصولات</h4>
              <QuickProductsTable
                products={products}
                deleteProduct={deleteProduct}
              />
            </div>
          </div>
          <SearchProduct
            ref={searchProductRef}
            handleShowProduct={handleShowProduct}
          />
        </div>
      </div>
    </>
  );
});
export default ProductsPack;
